// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LinkedText } from './LinkedText';
import {
    LinkedTextFromJSON,
    LinkedTextFromJSONTyped,
    LinkedTextToJSON,
    LinkedTextToJSONTyped,
} from './LinkedText';

/**
 * Hint for handicaped people at a StopPlace to board or alight a Vehicle on a PTRideLeg. Relates to `forBoarding` and `forAlighting`.
 * @export
 * @interface AccessibilityBoardingAlighting
 */
export interface AccessibilityBoardingAlighting {
    /**
     * The most relevant boarding/alighting accessibility restriction.<br>x-extensible-enum: [NO_HINT,BOARDING_ALIGHTING_SELF,BOARDING_ALIGHTING_BY_CREW,BOARDING_ALIGHTING_BY_NOTIFICATION,BOARDING_ALIGHTING_SHUTTLE_TRANSPORT,BOARDING_ALIGHTING_NOT_POSSIBLE]
     * @type {string}
     * @memberof AccessibilityBoardingAlighting
     */
    limitation: string;
    /**
     * Textual value for `limitation`.<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof AccessibilityBoardingAlighting
     */
    name: string;
    /**
     * Further description about `limitation` consequences.<br>(Translated according to Accept-Language.)
     * @type {string}
     * @memberof AccessibilityBoardingAlighting
     */
    description: string;
    /**
     * 
     * @type {LinkedText}
     * @memberof AccessibilityBoardingAlighting
     */
    assistanceService: LinkedText;
    /**
     * Icon-identifier to represent the related `limitation`. See [SBB Corporate-Identity catalog (CDN, aka FIGMA Icons)](https://www.figma.com/file/UQBd7cHKav0hr9oXYp7opJ/SBB-Icons?node-id=395%3A2952&t=ad26LgREBbTANSK5-1)
     * @type {string}
     * @memberof AccessibilityBoardingAlighting
     */
    corporateIdentityIcon: string;
}

/**
 * Check if a given object implements the AccessibilityBoardingAlighting interface.
 */
export function instanceOfAccessibilityBoardingAlighting(value: object): value is AccessibilityBoardingAlighting {
    if (!('limitation' in value) || value['limitation'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('assistanceService' in value) || value['assistanceService'] === undefined) return false;
    if (!('corporateIdentityIcon' in value) || value['corporateIdentityIcon'] === undefined) return false;
    return true;
}

export function AccessibilityBoardingAlightingFromJSON(json: any): AccessibilityBoardingAlighting {
    return AccessibilityBoardingAlightingFromJSONTyped(json, false);
}

export function AccessibilityBoardingAlightingFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessibilityBoardingAlighting {
    if (json == null) {
        return json;
    }
    return {
        
        'limitation': json['limitation'],
        'name': json['name'],
        'description': json['description'],
        'assistanceService': LinkedTextFromJSON(json['assistanceService']),
        'corporateIdentityIcon': json['corporateIdentityIcon'],
    };
}

  export function AccessibilityBoardingAlightingToJSON(json: any): AccessibilityBoardingAlighting {
      return AccessibilityBoardingAlightingToJSONTyped(json, false);
  }

  export function AccessibilityBoardingAlightingToJSONTyped(value?: AccessibilityBoardingAlighting | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'limitation': value['limitation'],
        'name': value['name'],
        'description': value['description'],
        'assistanceService': LinkedTextToJSON(value['assistanceService']),
        'corporateIdentityIcon': value['corporateIdentityIcon'],
    };
}

